"use client";

import { usePathname } from "next/navigation";
import QrPopup from "./qr-popup";

// QR popup shows on all (marketing) pages except these.
// (menu) routes are never reached here — they use a separate layout.
const EXCLUDED_PREFIXES = [
  // Auth & onboarding flows
  "/login",
  "/register",
  "/set-password",
  "/staff-invite",
  // Checkout flows (disruptive to show a popup mid-purchase)
  "/travel-esim/checkout",
  "/travel-esim/esim-plan",
  "/public-esim/checkout",
  // Compliance / regulated forms
  "/rfi-form",
  "/representative-form",
  // Utility
  "/maintenance",
];

export default function QrPopupGate() {
  const pathname = usePathname() || "";
  const isExcluded = EXCLUDED_PREFIXES.some((prefix) => pathname.startsWith(prefix));
  if (isExcluded) return null;
  return <QrPopup />;
}
